import { useMutation, UseMutationOptions } from 'react-query';

import { communityFeedApi } from 'src/Services/API';
import { StorageFileDto } from 'src/Services/API/generated';

export const useCreateCommunityFeedItemFile = (
  options?: UseMutationOptions<StorageFileDto, unknown, File>
) => {
  return useMutation<StorageFileDto, unknown, File>(
    'create-community-feed-item-file',
    async (file: File) => {
      const response = await communityFeedApi.communityFeedControllerCreateFeedItemFile(file);

      return response.data;
    },
    {
      ...options,
    }
  );
};
